import SectionHeading from '@/pages/home/components/SectionHeading';
import { corePerson, relationPaths } from '@/mocks/home';

export default function RelationsSection() {
  return (
    <section id="relations" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <SectionHeading
          eyebrow="圈内关系"
          title="顺着关系路径看线索"
          desc="从一位核心当事人出发，按关系类型逐条展开，把关联人物与涉事方的连接看得更清楚。"
        />

        <div className="mt-8 grid grid-cols-1 gap-4 md:gap-5 lg:grid-cols-3">
          <div className="flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 lg:col-span-1">
            <div className="h-52 w-full overflow-hidden">
              <img src={corePerson.image} alt={`${corePerson.name} 核心当事人封面`} className="h-full w-full object-cover object-top" />
            </div>
            <div className="flex flex-1 flex-col p-5">
              <span className="w-fit rounded-full bg-primary-100 px-2.5 py-1 font-label text-xs text-primary-700">{corePerson.role}</span>
              <h4 className="mt-3 font-heading text-xl font-bold text-foreground-950">{corePerson.name}</h4>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{corePerson.intro}</p>
              <div className="mt-4 flex items-center gap-2 border-t border-background-100 pt-3 font-label text-xs text-foreground-500">
                <i className="ri-links-line text-primary-500" />
                关联事件 · {corePerson.topic}
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-3 lg:col-span-2">
            {relationPaths.map((rel) => (
              <div
                key={`${rel.from}-${rel.to}-${rel.relation}`}
                className="rounded-lg border border-background-200 bg-background-100/60 p-4 transition-colors hover:border-accent-300"
              >
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded-md bg-background-50 px-2.5 py-1 text-sm font-medium text-foreground-950">{rel.from}</span>
                  <span className="flex items-center gap-1 font-label text-xs text-accent-700">
                    <i className="ri-arrow-right-line" />
                    {rel.relation}
                  </span>
                  <span className="rounded-md bg-background-50 px-2.5 py-1 text-sm font-medium text-foreground-950">{rel.to}</span>
                  <span className="ml-auto rounded-full bg-secondary-100 px-2 py-0.5 font-label text-[11px] text-secondary-900">{rel.topic}</span>
                </div>
                <p className="mt-2.5 text-xs leading-relaxed text-foreground-600 md:text-sm">{rel.note}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}